// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/contact_service.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * GetUnreadContactCountArgs メッセージ
 *
 * @generated from message service.GetUnreadContactCountArgs
 */
export class GetUnreadContactCountArgs extends Message<GetUnreadContactCountArgs> {
  constructor(data?: PartialMessage<GetUnreadContactCountArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.GetUnreadContactCountArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUnreadContactCountArgs {
    return new GetUnreadContactCountArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUnreadContactCountArgs {
    return new GetUnreadContactCountArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUnreadContactCountArgs {
    return new GetUnreadContactCountArgs().fromJsonString(jsonString, options);
  }

  static equals(a: GetUnreadContactCountArgs | PlainMessage<GetUnreadContactCountArgs> | undefined, b: GetUnreadContactCountArgs | PlainMessage<GetUnreadContactCountArgs> | undefined): boolean {
    return proto3.util.equals(GetUnreadContactCountArgs, a, b);
  }
}

/**
 * MarkContactAsReadArgs メッセージ
 *
 * @generated from message service.MarkContactAsReadArgs
 */
export class MarkContactAsReadArgs extends Message<MarkContactAsReadArgs> {
  /**
   * @generated from field: string contact_id = 1 [json_name = "contact_id"];
   */
  contactId = "";

  constructor(data?: PartialMessage<MarkContactAsReadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.MarkContactAsReadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact_id", jsonName: "contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkContactAsReadArgs {
    return new MarkContactAsReadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkContactAsReadArgs {
    return new MarkContactAsReadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkContactAsReadArgs {
    return new MarkContactAsReadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: MarkContactAsReadArgs | PlainMessage<MarkContactAsReadArgs> | undefined, b: MarkContactAsReadArgs | PlainMessage<MarkContactAsReadArgs> | undefined): boolean {
    return proto3.util.equals(MarkContactAsReadArgs, a, b);
  }
}

/**
 * MarkContactAsUnreadArgs メッセージ
 *
 * @generated from message service.MarkContactAsUnreadArgs
 */
export class MarkContactAsUnreadArgs extends Message<MarkContactAsUnreadArgs> {
  /**
   * @generated from field: string contact_id = 1 [json_name = "contact_id"];
   */
  contactId = "";

  constructor(data?: PartialMessage<MarkContactAsUnreadArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.MarkContactAsUnreadArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact_id", jsonName: "contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkContactAsUnreadArgs {
    return new MarkContactAsUnreadArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkContactAsUnreadArgs {
    return new MarkContactAsUnreadArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkContactAsUnreadArgs {
    return new MarkContactAsUnreadArgs().fromJsonString(jsonString, options);
  }

  static equals(a: MarkContactAsUnreadArgs | PlainMessage<MarkContactAsUnreadArgs> | undefined, b: MarkContactAsUnreadArgs | PlainMessage<MarkContactAsUnreadArgs> | undefined): boolean {
    return proto3.util.equals(MarkContactAsUnreadArgs, a, b);
  }
}

/**
 * GetUnreadContactCountReply メッセージ
 *
 * @generated from message service.GetUnreadContactCountReply
 */
export class GetUnreadContactCountReply extends Message<GetUnreadContactCountReply> {
  /**
   * @generated from field: int32 unread_count = 1 [json_name = "unread_count"];
   */
  unreadCount = 0;

  constructor(data?: PartialMessage<GetUnreadContactCountReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.GetUnreadContactCountReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unread_count", jsonName: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUnreadContactCountReply {
    return new GetUnreadContactCountReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUnreadContactCountReply {
    return new GetUnreadContactCountReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUnreadContactCountReply {
    return new GetUnreadContactCountReply().fromJsonString(jsonString, options);
  }

  static equals(a: GetUnreadContactCountReply | PlainMessage<GetUnreadContactCountReply> | undefined, b: GetUnreadContactCountReply | PlainMessage<GetUnreadContactCountReply> | undefined): boolean {
    return proto3.util.equals(GetUnreadContactCountReply, a, b);
  }
}

/**
 * MarkContactAsReadReply メッセージ
 *
 * @generated from message service.MarkContactAsReadReply
 */
export class MarkContactAsReadReply extends Message<MarkContactAsReadReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<MarkContactAsReadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.MarkContactAsReadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkContactAsReadReply {
    return new MarkContactAsReadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkContactAsReadReply {
    return new MarkContactAsReadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkContactAsReadReply {
    return new MarkContactAsReadReply().fromJsonString(jsonString, options);
  }

  static equals(a: MarkContactAsReadReply | PlainMessage<MarkContactAsReadReply> | undefined, b: MarkContactAsReadReply | PlainMessage<MarkContactAsReadReply> | undefined): boolean {
    return proto3.util.equals(MarkContactAsReadReply, a, b);
  }
}

/**
 * MarkContactAsUnreadReply メッセージ
 *
 * @generated from message service.MarkContactAsUnreadReply
 */
export class MarkContactAsUnreadReply extends Message<MarkContactAsUnreadReply> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<MarkContactAsUnreadReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.MarkContactAsUnreadReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MarkContactAsUnreadReply {
    return new MarkContactAsUnreadReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MarkContactAsUnreadReply {
    return new MarkContactAsUnreadReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MarkContactAsUnreadReply {
    return new MarkContactAsUnreadReply().fromJsonString(jsonString, options);
  }

  static equals(a: MarkContactAsUnreadReply | PlainMessage<MarkContactAsUnreadReply> | undefined, b: MarkContactAsUnreadReply | PlainMessage<MarkContactAsUnreadReply> | undefined): boolean {
    return proto3.util.equals(MarkContactAsUnreadReply, a, b);
  }
}

